import makeStyles from "@material-ui/core/styles/makeStyles"

export const useContentItemStyle = makeStyles({
    root: {
        color: "white",
        backgroundColor: "#999",
        position: "absolute",
        borderRadius: 6,
        width: "90%",
        height: 40,
        right: 4,
        top: 4,
        zIndex: 1,
        padding: "0 20px 0 10px",
        cursor: "pointer",
        transition: "all .3s ease",
        wordBreak: "break-word",
        userSelect: "none",
        overflowY: "scroll",
    },
    icon: {
        fontWeight: "bold",
        position: "absolute",
        right: 1,
        top: 0,
        opacity: 0,
    },
    iconShow: {
        opacity: 1,
    },
})
